<template>
  <ModalWrapper :title="title" :callbackCancel="callbackCancel">
    <div class="modal-conform">
      <div class="modal-conform__form" v-if="withCode">
        <UiField
          label="Код"
          v-model="formCode"
        />
      </div>
      <div class="modal-buttons">
        <UiButton @click="() => {callbackCancel(); close()}">Отмена</UiButton>
        <UiButton
          @click="() => {callbackConform(formCode); close()}"
          :disabled="withCode ? formCode.length == 0 : false"
        >Подтвердить</UiButton>
      </div>
    </div>
  </ModalWrapper>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import ModalWrapper from '@/components/popups/ModalWrapper.vue'
import UiButton from '@/components/ui/UiButton.vue'
import UiField from '@/components/ui/UiField.vue'
export default {
  components: {
    ModalWrapper,
    UiButton,
    UiField
  },
  props: {
    withCode: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    callbackConform: {
      type: Function,
      default: null
    },
    callbackCancel: {
      type: Function,
      default: null
    }
  },
  setup () {
    const formCode = ref('')
    const store = useStore()
    return {
      formCode,
      close () {
        store.dispatch('closePopup')
      }
    }
  }
}
</script>

<style lang="scss">
.modal-conform {
  &__form {
    margin-bottom: 20px;
    width: 300px;
  }
}
</style>
